export default "__VITE_ASSET__DQwPj7rS__"